__turbopack_context__.v({
  "carousel": "YouMightAlsoLikePrizeGrouping-module__j1Yi2a__carousel",
  "container": "YouMightAlsoLikePrizeGrouping-module__j1Yi2a__container",
  "headingContainer": "YouMightAlsoLikePrizeGrouping-module__j1Yi2a__headingContainer",
});
